module.exports = __webpack_public_path__ + "img/invalid-token_new.54546dac.svg";